<app-header
  [navItems]="settingsMenu"
  [enableBack]="false"
>
  <div title>{{ 'settings.title' | translate }}</div>
</app-header>

<div class="p-6 flex gap-8 items-start">

  <!-- Page content -->
  <div class="flex-1 min-w-0">
    <router-outlet></router-outlet>
  </div>

  <!-- Persistent user panel -->
  @if (userService.user()) {
    <div class="w-1/3 shrink-0 hidden xl:flex flex-col gap-4">

      <!-- Avatar + name + email -->
      <div class="bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border shadow-sm p-5 flex flex-col items-center gap-3 text-center">
        <div class="rounded-full w-20 h-20 bg-gray-100 dark:bg-dark-hover flex items-center justify-center text-2xl font-bold text-gray-500 dark:text-dark-muted select-none">
          {{ (userService.user()?.name ?? '') | initials }}
        </div>
        <div class="w-full">
          <div class="text-base font-medium text-gray-800 dark:text-white leading-tight">
            {{ userService.user()?.name }}
          </div>
          <div class="border-t border-gray-100 dark:border-dark-border my-2"></div>
          <div class="text-sm text-gray-400 dark:text-dark-muted">
            {{ userService.user()?.username }}
          </div>
        </div>
      </div>

      <!-- Roles table -->
      @if (tableRoles.length > 0) {
        <app-table [config]="tableConfig" [data]="tableRoles"></app-table>
      }

    </div>
  }

</div>
